import {useSelector} from "react-redux";

import {IInfiniteListQuery} from "@pg-design/infinite-list";

import {IRPStore} from "../../app/rp_reducer";
import {HOMEPAGE_OFFERS_PANEL_LIST_PAGE, HOMEPAGE_OFFERS_PANEL_LIST_PAGE_SIZE} from "../../homepage/actions/fetch_homepage_offer_list";
import {getQueryStatus} from "../../request/get_query_status";
import {IOfferListOffer} from "../types/IOfferListOffer";

export function useHomepageOffers(): IInfiniteListQuery<IOfferListOffer> {
    const recommendedOffersList = useSelector((state: IRPStore) => state.homepage.recommendedOfferList);
    const recommendedOffersRequest = useSelector((state: IRPStore) => state.homepage.requestState);
    //TODO can delete unique logic after api fixes from CU-8699jw11j
    const uniqueOffers = recommendedOffersList.reduce(
        (acc, offer) => (acc.find((accOffer) => accOffer.id === offer.id) ? acc : [...acc, offer]),
        [] as IOfferListOffer[]
    );
    return {
        ...getQueryStatus(recommendedOffersRequest),
        data: uniqueOffers,
        count: uniqueOffers.length,
        requestState: recommendedOffersRequest,
        page: HOMEPAGE_OFFERS_PANEL_LIST_PAGE,
        pageSize: HOMEPAGE_OFFERS_PANEL_LIST_PAGE_SIZE
    };
}
import {useSelector} from "react-redux";

import {IInfiniteListQuery} from "@pg-design/infinite-list";

import {IRPStore} from "../../app/rp_reducer";
import {HOMEPAGE_OFFERS_PANEL_LIST_PAGE, HOMEPAGE_OFFERS_PANEL_LIST_PAGE_SIZE} from "../../homepage/actions/fetch_homepage_offer_list";
import {getQueryStatus} from "../../request/get_query_status";
import {IOfferListOffer} from "../types/IOfferListOffer";

export function useHomepageOffers(): IInfiniteListQuery<IOfferListOffer> {
    const recommendedOffersList = useSelector((state: IRPStore) => state.homepage.recommendedOfferList);
    const recommendedOffersRequest = useSelector((state: IRPStore) => state.homepage.requestState);
    //TODO can delete unique logic after api fixes from CU-8699jw11j
    const uniqueOffers = recommendedOffersList.reduce(
        (acc, offer) => (acc.find((accOffer) => accOffer.id === offer.id) ? acc : [...acc, offer]),
        [] as IOfferListOffer[]
    );
    return {
        ...getQueryStatus(recommendedOffersRequest),
        data: uniqueOffers,
        count: uniqueOffers.length,
        requestState: recommendedOffersRequest,
        page: HOMEPAGE_OFFERS_PANEL_LIST_PAGE,
        pageSize: HOMEPAGE_OFFERS_PANEL_LIST_PAGE_SIZE
    };
}
